module.exports = {
  defaultConfig: {
    orgName: 'Skycatch',
    logoUrl: '//{ASSETS_DOMAIN}/images/skycatch-dark.svg',
    smallLogoUrl: '//{ASSETS_DOMAIN}/images/logo-blue.svg',
    logoBackgroundColor: '#3D454F',
    topnavBackgroundColor: '#24313B',

    default: true
  },

  clientConfig: {
    2608: {
      orgName: 'SkySnap',
      logoUrl: '//{ASSETS_DOMAIN}/images/custom_logo/skysnap.png',
      smallLogoUrl: '//{ASSETS_DOMAIN}/images/custom_logo/skysnap-mobile.png',
      default: false
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/tmpConfig/brand.js